import { create } from 'zustand'

type InputId = string
type Value = string | undefined
type Registry = Record<InputId, Value>

type InputsRegistry = {
  registry: Registry
  setRegistryValue: (inputId: InputId, value: Value) => void
  destroyInput: (inputId: InputId) => void
}

const useInputsRegistry = create<InputsRegistry>(set => ({
  registry: {},
  setRegistryValue: (inputId, value) => {
    set(state => ({
      registry: { ...state.registry, [inputId]: value }
    }))
  },
  destroyInput: inputId => {
    set(state => {
      const { [inputId]: _, ...rest } = state.registry

      return { registry: rest }
    })
  }
}))

export default useInputsRegistry
